import { render, staticRenderFns } from "./restaurant-form.vue?vue&type=template&id=e43ffc9a"
import script from "./restaurant-form.vue?vue&type=script&lang=js"
export * from "./restaurant-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports